import { createContext, useContext, useMemo, useState } from "react";
import { useDashboardAccess } from "./DashboardAccessProvider";
import { DrillDownConfig } from "./types";
import { DrillDownDialog } from "./widgets/DrillDownDialog";

type DrillDownContextValue = {
    openDrillDown: (config: DrillDownConfig) => void;
};

const DrillDownContext = createContext<DrillDownContextValue | null>(null);

export const useDrillDownDialog = () => {
    const context = useContext(DrillDownContext);
    return context;
};

type DrillDownProviderProps = {
    children: React.ReactNode;
};

export const DrillDownProvider = ({ children }: DrillDownProviderProps) => {
    const { canDrill } = useDashboardAccess();
    const [activeConfig, setActiveConfig] = useState<DrillDownConfig | null>(null);
    const contextValue = useMemo(() => ({ openDrillDown: setActiveConfig }), []);

    // Sem drill para este role: contexto null → todos os widgets degradam para não-clicáveis.
    return (
        <DrillDownContext.Provider value={canDrill ? contextValue : null}>
            {children}
            {activeConfig && <DrillDownDialog config={activeConfig} onClose={() => setActiveConfig(null)} />}
        </DrillDownContext.Provider>
    );
};
